ko.bindingHandlers.datepicker = {
    init: function(element, valueAccessor, allBindingsAccessor) {
        var underlyingObservable = valueAccessor();

        var options = allBindingsAccessor().datepickerOptions ||
        {
            locale: "pt-br",
            keepOpen: false,
            format: "DD/MM/YYYY"
        };

        var interceptor = ko.computed({
            read: function() {
                var value = global.formatDate(underlyingObservable(), options.format);
                return value ? value : null;
            },

            write: function(newValue) {
                var current = underlyingObservable();

                if (newValue !== current) {
                    underlyingObservable(newValue);
                    underlyingObservable.valueHasMutated();
                }
            }
        });

        $(element)
            .closest("div.input-group.date")
            .datetimepicker(options)
            .on("dp.change",
                function(e) {
                    var observable = valueAccessor();
                    observable(global.formatDate(e.date, options.format));
                });


        if ($._data(element, "events") && $._data(element, "events").keydown) {
            $.each($._data(element, "events").keydown,
                function() {

                    if (!this.handler) {
                        return;
                    }

                    var handler = this.handler;

                    this.handler = $.proxy(function(h, e) {
                            var event = $.Event("dpkeypress");
                            event.which = e.which;
                            $(this).trigger(event);
                            h(e);
                        },
                        element,
                        handler);

                });
        }

        ko.applyBindingsToNode(element, { value: interceptor, valueUpdate: "keyup" });
    }
};